import(/* webpackMode: "eager" */ "/vercel/path0/app/(routes)/mentor/page.jsx");
